import appConfig from "@/app.config";

const schema = {
  tabs: [
    {
      title: 'Pages',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Pages",
      activeBtn: false,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: 'Add New Page',
      formData: {},
      schema: {
      name: {
        type: 'text',
        label: 'Page Title',
        placeholder: 'Enter Page Title',
        required: true,
        info: false,
        character_count: 50
        },
      },
      side_panel: {
        select_a_page: {
          type: 'list',
          label: 'Select Page',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: []
        }
      },
      form: {
        title: {
            type: 'text',
            label: 'Page Title',
            placeholder: 'Enter Page Title',
            required: true,
            info: true,
            character_count: 250,
            disabled: false,
            wrapper_class: ''
          },
        slug: {
          type: 'text',
          label: 'Slug',
          placeholder: 'Enter Slug',
          required: true,
          info: true,
          character_count: 50,
          disabled: false,
          wrapper_class: ''
        },
        subtitle: {
          type: 'text',
          label: 'Sub-title',
          placeholder: 'Enter Sub-title',
          required: true,
          info: true,
          character_count: 250,
          disabled: false,
          wrapper_class: ''
        },
        info_box: {
          type: 'checkbox',
          label: 'Add Information Box',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [
            {
              name: 'Add Information Box',
              value: false
            }
          ]
        },
        info_title: {
          type: 'text',
          label: 'Info Title',
          placeholder: 'Enter Info Title',
          required: true,
          info: false,
          character_count: 250,
          disabled: false,
          wrapper_class: ''
        },
        info_description: {
          type: 'ckeditor',
          label: 'Info Description',
          placeholder: 'Enter Description',
          required: true,
          info: false,
          character_count: 2000,
          disabled: false,
          wrapper_class: '',
        },
        description: {
          type: 'ckeditor',
          label: 'Description',
          placeholder: 'Enter Description',
          required: true,
          info: true,
          character_count: 2000,
          disabled: false,
          wrapper_class: ''
        },
      }
    }
  ]
};

export { schema };